module.exports = __webpack_public_path__ + "static/media/producer-mic-mute-icon.b824c4e6.svg";